import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { UserContext } from "../context/user";
import { HotelContext } from "../context/hotel";
import { useLocation } from 'react-router-dom';

const PrivateRoute = ({ component }) => {
  const location = useLocation();

  const { initied, RoomOccupation } = useContext(UserContext);
  const { getUrlPath } = useContext(HotelContext)

  if (initied || RoomOccupation?.id) {
    return component;
  }

  const relative = location.pathname
    .replace(getUrlPath(""), "")
    .replace(/^\//, "");
  const identifyPath = getUrlPath("checkin/identify");
  const to = relative
    ? `${identifyPath}?redirect=${encodeURIComponent(relative)}`
    : identifyPath;

  return <Navigate to={to} replace />;
};

export default PrivateRoute;
